<div class="section">
  <div class="section__header">
    <h2 class="section__header-text">Description <mat-icon (click)="openEditDescDialog()" *ngIf="editModeSet" class="edit-icon">edit</mat-icon></h2>
  </div>
  <div class="section__body">
    <div class="section__content event-desc__content" [innerHTML]="aviationEvent.description">
    </div>
  </div>
</div>
